<template>
  <div>
    <base-page-heading title="Vendors">
      <template #extra>
        <b-button
          v-if="$can('create', 'Vendor')"
          variant="primary"
          v-b-modal.vendor-add-modal
          v-b-tooltip.hover
          title="Create a new Vendor"
        >
          <i class="fa fa-plus" />
          <span class="ml-1 d-none d-md-inline">New Vendor</span>
        </b-button>
        <b-dropdown
          v-if="$can('create', 'Supply')"
          text="Import"
          variant="outline-secondary"
          right
        >
          <template #button-content>
            <i class="fa fa-file-excel" />
            <span class="ml-1 d-none d-md-inline">Import</span>
          </template>
          <b-dropdown-item v-b-modal.supplies-imports-add-modal>
            Create / Update Supplies
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </base-page-heading>
    <div class="content">
      <b-row>
        <b-col>
          <vendors-list-filter
            :table-name="tableName"
            :columns="columns"
            :initial-filters="filters"
            @filters-applied="applyFilters"
          />
        </b-col>
      </b-row>

      <vendors-table
        :filters="filters"
        :columns="columns"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
      />
    </div>
    <!-- Page Modals -->
    <vendors-new-modal v-if="$can('create', 'Vendor')" />
    <supplies-import-new-modal v-if="$can('create', 'Supply')" />
  </div>
</template>

<script>
import VendorsNewModal from '@/components/admin/vendors/NewModal.vue';
import VendorsTable from '@/components/admin/vendors/Table.vue';
import VendorsListFilter from '@/components/admin/vendors/ListFilter.vue';
import SuppliesImportNewModal from '@/components/admin/imports/SuppliesNewModal.vue';
import listMixin from '@/mixins/listMixin';
import { VENDOR_TABLE_NAME } from '@/constants/vendors';

export default {
  name: 'VendorsList',
  components: {
    VendorsNewModal,
    VendorsListFilter,
    VendorsTable,
    SuppliesImportNewModal,
  },
  mixins: [listMixin],
  props: {
    text: String,
    name: String,
    city: String,
    state: String,
    account_number: String,
  },
  data() {
    return {
      tableName: VENDOR_TABLE_NAME,
      filters: {
        text: this.text,
        name: this.name,
        city: this.city,
        state: this.state,
        account_number: this.account_number,
      },
    };
  },
};
</script>
